import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { SecurityService } from 'src/app/shared/services/security.service';
export class ModalAddEditRutasComponent {
    constructor(fb, clog, accesolocalstorage, recorridoService, messageRendererService, choferSucursalService, camionSucursalService, datesService, camionChoferService) {
        this.fb = fb;
        this.clog = clog;
        this.accesolocalstorage = accesolocalstorage;
        this.recorridoService = recorridoService;
        this.messageRendererService = messageRendererService;
        this.choferSucursalService = choferSucursalService;
        this.camionSucursalService = camionSucursalService;
        this.datesService = datesService;
        this.camionChoferService = camionChoferService;
        this.onSuccess = new EventEmitter();
        this.recorridoSeleccionado = null;
        this.optionsChofer = [];
        this.optionsCamion = [];
        this.camion = null;
        this.chofer = null;
        this.loadingCamiones = false;
        this.loadingChoferes = false;
        this.datosCargados = false;
        this.log = this.clog.log('RUTEADOR ADD EDIT');
    }
    ngOnInit() {
        this.createForm();
        this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
        this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
        this.latitudEmpresa = this.accesolocalstorage.getLatitudEmpresa();
        this.longitudEmpresa = this.accesolocalstorage.getLongitudEmpresa();
        // Cargar datos y establecer el estado de carga
        Promise.all([
            this.loadCamiones(),
            this.loadChofer()
        ]).then(() => {
            this.datosCargados = true;
        }).catch(error => {
            console.error('Error al cargar los datos:', error);
            this.messageRendererService.showErrors(['Error al cargar los datos necesarios.']);
        });
        this.formChangesSubscriptions();
    }
    formChangesSubscriptions() {
        this.formRuta.get("camion").valueChanges
            .subscribe((patente) => {
            if (!patente) {
                //this.formHeader.get('cantidad').setValue(0)
                return;
            }
            this.loadChoferCamion(patente);
        });
    }
    createForm() {
        this.formRuta = this.fb.group({
            chofer: [''],
            camion: [''],
            negocio: [''],
            nroDoc: [''],
            monto: [''],
            fechaMain: [null],
        });
    }
    loadCamiones() {
        this.loadingCamiones = true;
        return new Promise((resolve, reject) => {
            this.camionSucursalService.obtenerCamionSucursalxRutEmpresaSucursal({
                rut_empresa: this.rutEmpresa,
                sucursal_codigo: this.sucursalCodigo,
                tipobusqueda: 1,
            }, ({ respuesta, mensajes }) => {
                this.loadingCamiones = false;
                if (mensajes && mensajes.length > 0) {
                    this.messageRendererService.showErrors(mensajes);
                    reject(mensajes);
                    return;
                }
                const { registros } = respuesta;
                this.optionsCamion = registros.map((_a) => {
                    var { patente, descripcion } = _a, rest = tslib_1.__rest(_a, ["patente", "descripcion"]);
                    return (Object.assign({ value: patente, label: `${patente} ${descripcion}` }, rest));
                });
                // Validar que recorridoSeleccionado no sea null y tenga patente
                if (this.recorridoSeleccionado && this.recorridoSeleccionado.patente) {
                    const camionEncontrado = registros.find(c => c.patente === this.recorridoSeleccionado.patente);
                    this.camionSeleccionado = camionEncontrado ? camionEncontrado.patente : null;
                }
                else {
                    this.camionSeleccionado = null;
                }
                if (this.camionSeleccionado) {
                    this.formRuta.get('camion').setValue(this.camionSeleccionado);
                    this.setCamion();
                }
                resolve();
            });
        });
    }
    loadChofer() {
        this.loadingChoferes = true;
        return new Promise((resolve, reject) => {
            const inputParams = {
                entidad: {
                    rut_empresa: this.rutEmpresa,
                    sucursal_codigo: this.sucursalCodigo,
                    tipobusqueda: 1,
                },
            };
            this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
                this.loadingChoferes = false;
                if (mensajes && mensajes.length > 0) {
                    this.messageRendererService.showErrors(mensajes);
                    reject(mensajes);
                    return;
                }
                const { registros } = respuesta;
                this.optionsChofer = registros.map((p) => (Object.assign({ value: p.rut, label: p.nombre }, p)));
                resolve();
            });
        });
    }
    loadChoferCamion(cam) {
        const inputParams = {
            entidad: {
                patente: cam,
            },
        };
        this.camionChoferService.obtenerSegunPatente(inputParams, ({ respuesta, mensajes }) => {
            if (mensajes && mensajes.length > 0) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            this.choferSeleccionado = respuesta.rut_chofer;
            // Verificar si respuesta.rut_chofer es válido
            if (respuesta && respuesta.rut_chofer > 0) {
                this.formRuta.get('chofer').setValue(this.choferSeleccionado);
                this.setChofer();
            }
        });
    }
    showAdd() {
        const { currentDate } = this.datesService.GetStartAndCurrentMonth();
        this.clearModal();
        this.formRuta.get('fechaMain').setValue(currentDate);
        this.verAddEditRutasModal.show();
    }
    showEdit(cam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log(cam);
            this.formRuta.get('fechaMain').setValue(cam.fecha);
            this.verAddEditRutasModal.show();
            this.recorridoSeleccionado = {
                checked: false,
                chofer_rut: cam.chofer_rut,
                fecha: cam.fecha,
                nombre_chofer: cam.nombre_chofer,
                patente: cam.patente,
                // index:    0
                recorrido_codigo: cam.recorrido_codigo,
                total_facturas: cam.total_facturas,
            };
            this.recorridoSeleccionado = cam;
            console.log('=>(ruteador.component.ts:185) this.recorridoSeleccionado', this.recorridoSeleccionado);
            if (this.recorridoSeleccionado && this.recorridoSeleccionado.patente && this.recorridoSeleccionado.chofer_rut) {
                this.formRuta.get('camion').setValue(this.recorridoSeleccionado.patente);
                this.formRuta.get('chofer').setValue(this.recorridoSeleccionado.chofer_rut);
                this.setCamion();
                this.setChofer();
            }
        });
    }
    addRuta() {
        this.loading = true;
        const inputParams = {
            entidad: {
                codigo: this.recorridoSeleccionado ? this.recorridoSeleccionado.recorrido_codigo : null,
                chofer_rut: this.formRuta.get('chofer').value,
                camion_patente: this.camion.value,
                sucursal_codigo: this.sucursalCodigo,
                rut_empresa: this.rutEmpresa,
                limite_volumen: this.camion.volumen,
                limite_monto: 10000000,
                limite_peso: this.camion.peso_maximo,
                fecha_registro: this.formRuta.get('fechaMain').value,
                fecha: this.formRuta.get('fechaMain').value,
                activo: true,
                latitud_origen: this.latitudEmpresa,
                longitud_origen: this.longitudEmpresa,
            },
        };
        this.log('inputParams', JSON.stringify(inputParams));
        this.recorridoService.guardar(inputParams, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            const { empresa_rut } = respuesta;
            this.onSuccess.emit();
            // this.showSuccess('Operación Realizada');
            // this.postProcesoAddRuta();
            // this.buscarRecorridos();
        });
        this.loading = false;
        this.clearModal();
    }
    setChofer() {
        this.chofer = this.optionsChofer.filter((s) => s.value == this.formRuta.get('chofer').value)[0];
    }
    setCamion() {
        this.camion = this.optionsCamion.filter((s) => s.value == this.formRuta.get('camion').value)[0];
    }
    clearModal() {
        this.formRuta.reset();
        this.camion = null;
        this.chofer = null;
        this.recorridoSeleccionado = null;
    }
    CerrarModal() {
        this.clearModal();
        this.verAddEditRutasModal.hide();
    }
}
